export const PANEL_NAME = 'Landing Pages';
export const DEFAULT_ENTITY_NAME = 'Untitled Landing Page';
export const CONFIRM_DELETE_ENTITY_TEXT = 'Delete landing page?';
export const getDefaultHeading = (fbPageName: string) =>
  `Subscribe to Updates from ${fbPageName} via Facebook Messenger`;
export const getDefaultText = (fbPageName: string) =>
  // tslint:disable-next-line
  `Click the blue "Learn more in Messenger" button below for occasional news, and important information from ${fbPageName}.

You may unsubscribe at any time by typing "stop" or "unsubscribe".`;
export const UNIQUE_LINK_SLUG_ERROR = 'Link slug should be unique for the bot';
export const SHORT_LINK_SLUG_ERROR =
  'Link slug should be 1 or more characters long';
export const INVALID_LINK_SLUG_ERROR =
  'Link slug should only contain latin letters, numbers, - (dash) symbol';
export const DEFAULT_BG_COLOR = '#eef1f8';
export const ALIGNMENT_TYPES = {
  CENTER: 'center',
  LEFT: 'left',
  RIGHT: 'right',
};

const messageButtons = [
  'GET_THIS_IN_MESSENGER',
  'RECEIVE_THIS_IN_MESSENGER',
  'SEND_THIS_TO_ME',
  'GET_CUSTOMER_ASSISTANCE',
  'GET_CUSTOMER_SERVICE',
  'GET_SUPPORT',
  'LET_US_CHAT',
  'SEND_ME_MESSAGES',
  'ALERT_ME_IN_MESSENGER',
  'SEND_ME_UPDATES',
  'MESSAGE_ME',
  'LET_ME_KNOW',
  'KEEP_ME_UPDATED',
  'TELL_ME_MORE',
  'SUBSCRIBE_IN_MESSENGER',
  'SUBSCRIBE_TO_UPDATES',
  'GET_MESSAGES',
  'SUBSCRIBE',
  'GET_STARTED_IN_MESSENGER',
  'LEARN_MORE_IN_MESSENGER',
  'GET_STARTED',
];

export const MSG_BUTTON_TYPES: any = {};
messageButtons.forEach(m => {
  MSG_BUTTON_TYPES[m] = m;
});

export const MESSENGER_BUTTON_MESSAGES = {
  [MSG_BUTTON_TYPES.GET_THIS_IN_MESSENGER]: 'Get this in Messenger',
  [MSG_BUTTON_TYPES.RECEIVE_THIS_IN_MESSENGER]: 'Receive this in Messenger',
  [MSG_BUTTON_TYPES.SEND_THIS_TO_ME]: 'Send this to me',
  [MSG_BUTTON_TYPES.GET_CUSTOMER_ASSISTANCE]: 'Get customer assistance',
  [MSG_BUTTON_TYPES.GET_CUSTOMER_SERVICE]: 'Get customer service',
  [MSG_BUTTON_TYPES.GET_SUPPORT]: 'Get support',
  [MSG_BUTTON_TYPES.LET_US_CHAT]: "Let's chat",
  [MSG_BUTTON_TYPES.SEND_ME_MESSAGES]: 'Send me messages',
  [MSG_BUTTON_TYPES.ALERT_ME_IN_MESSENGER]: 'Alert me in Messenger',
  [MSG_BUTTON_TYPES.SEND_ME_UPDATES]: 'Send me updates',
  [MSG_BUTTON_TYPES.MESSAGE_ME]: 'Message me',
  [MSG_BUTTON_TYPES.LET_ME_KNOW]: 'Let me know',
  [MSG_BUTTON_TYPES.KEEP_ME_UPDATED]: 'Keep me updated',
  [MSG_BUTTON_TYPES.TELL_ME_MORE]: 'Tell me more',
  [MSG_BUTTON_TYPES.SUBSCRIBE_IN_MESSENGER]: 'Subscribe in Messenger',
  [MSG_BUTTON_TYPES.SUBSCRIBE_TO_UPDATES]: 'Subscribe to updates',
  [MSG_BUTTON_TYPES.GET_MESSAGES]: 'Get messages',
  [MSG_BUTTON_TYPES.SUBSCRIBE]: 'Subscribe',
  [MSG_BUTTON_TYPES.GET_STARTED_IN_MESSENGER]: 'Get started in Messenger',
  [MSG_BUTTON_TYPES.LEARN_MORE_IN_MESSENGER]: 'Learn more in Messenger',
  [MSG_BUTTON_TYPES.GET_STARTED]: 'Get started',
};
